/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Application_Overview_TabInputs */

const en_landing_application_overview_tab = /** @type {(inputs: Landing_Application_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications`)
};

const de_landing_application_overview_tab = /** @type {(inputs: Landing_Application_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen`)
};

const fr_landing_application_overview_tab = /** @type {(inputs: Landing_Application_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidatures`)
};

const es_landing_application_overview_tab = /** @type {(inputs: Landing_Application_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitudes`)
};

const it_landing_application_overview_tab = /** @type {(inputs: Landing_Application_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidature`)
};

const nl_landing_application_overview_tab = /** @type {(inputs: Landing_Application_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitaties`)
};

const pl_landing_application_overview_tab = /** @type {(inputs: Landing_Application_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacje`)
};

const fi_landing_application_overview_tab = /** @type {(inputs: Landing_Application_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakemukset`)
};

const da_landing_application_overview_tab = /** @type {(inputs: Landing_Application_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgninger`)
};

const sv_landing_application_overview_tab = /** @type {(inputs: Landing_Application_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökningar`)
};

/**
* | output |
* | --- |
* | "Applications" |
*
* @param {Landing_Application_Overview_TabInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_application_overview_tab = /** @type {((inputs?: Landing_Application_Overview_TabInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Application_Overview_TabInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_application_overview_tab(inputs)
	if (locale === "fr") return fr_landing_application_overview_tab(inputs)
	if (locale === "es") return es_landing_application_overview_tab(inputs)
	if (locale === "it") return it_landing_application_overview_tab(inputs)
	if (locale === "nl") return nl_landing_application_overview_tab(inputs)
	if (locale === "pl") return pl_landing_application_overview_tab(inputs)
	if (locale === "fi") return fi_landing_application_overview_tab(inputs)
	if (locale === "da") return da_landing_application_overview_tab(inputs)
	if (locale === "sv") return sv_landing_application_overview_tab(inputs)
	return en_landing_application_overview_tab(inputs)
});